export const FormatAddresses = (userAddress: string): string => {
  if (!userAddress) {
    return '';
  }
  const firstPart = userAddress.slice(0, 4);
  const lastPart = userAddress.slice(-4);
  return `${firstPart}............${lastPart}`;
};
